import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';
setAutoFreeze(false); // 禁止凍結

const localAirport = JSON.parse(
  sessionStorage.getItem('custom-itinerary-airport'),
);

const initialState = {
  // 已存入行程的資料
  entryData: localAirport?.entryData || {},
  departureData: localAirport?.departureData || {},

  // 查詢結果的資料
  searchData: localAirport?.searchData || [],

  // 查詢結果中被選取的目標
  entryPick: localAirport?.entryPick || '',
  departurePick: localAirport?.departurePick || '',
};

export const airportSlice = createSlice({
  name: 'airport',
  initialState,
  reducers: {
    airportUpdate: (state, action) => {
      const newState = {
        ...state,
        ...action.payload,
      };

      sessionStorage.setItem(
        'custom-itinerary-airport',
        JSON.stringify(newState),
      );

      return newState;
    },
    airportReset: () => {
      sessionStorage.removeItem('custom-itinerary-airport');

      return {
        entryData: {},
        departureData: {},
        searchData: [],
        entryPick: '',
        departurePick: '',
      };
    },
  },
});

/** 調整行程2.5 - 機場資訊 */
export const airportSelect = (state) => state.airport;
export const { airportUpdate, airportReset } = airportSlice.actions;
export default airportSlice.reducer;
